import { parseGlobIcon } from '@utils/parse-glob-icon';
import { type FC } from 'react';
import styles from './index.module.scss';

interface OwnsProps {
  address: string;
  className?: string;
}

const getUserIcon = parseGlobIcon(
  import.meta.glob('../../assets/images/avatar/*', {
    eager: true,
    import: 'default',
  }),
);

function hexToSingleNumberInRange(hex: string): number {
  if (hex.startsWith('0x')) {
    hex = hex.slice(2);
  }

  // 将 hex 转换为字节数组
  const bytes: number[] = [];
  for (let i = 0; i < hex.length; i += 2) {
    const byte = parseInt(hex.slice(i, i + 2), 16);
    if (!isNaN(byte)) {
      bytes.push(byte);
    }
  }

  // 将所有字节累加求和（或也可以 XOR、哈希等方式）
  const sum = bytes.reduce((acc, val) => acc + val, 0);

  // 映射到 1~76
  return (sum % 76) + 1;
}

const Avatar: FC<OwnsProps> = ({ address, className }) => {
  const num = hexToSingleNumberInRange(address);
  return <img src={getUserIcon(`Avatar-${num}`)} className={`${styles.img} ${className}`} />;
};

export default Avatar;
